import React, { useContext, useEffect, useState } from 'react';
import { ThemeProvider, useTheme } from '../Contexts/ThemeContext';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { Icon, Page, Select, SidebarNav, SidebarNavContent, SidebarNavHeader, SidebarNavMenu, SidebarNavMenuButton, SidebarNavMenuItem, SidebarNavProvider } from '@aidkitorg/component-library';
import { NavigationNode } from '@aidkitorg/types/lib/translation/permissions';
import { langToWord } from '../Localization';
import InterfaceContext, { PublicConfigurationContext, SupportedLanguage } from '../Context';
import { SelectOptionType } from '@aidkitorg/component-library/dist/types/src/Select';
import { Text } from '@aidkitorg/types/lib/survey';

const NAV_ITEMS: Array<NavigationNode> = [
  {
    name: 'Dashboard Home',
    href: '/adminpanel/overview'
  },
  {
    name: 'Payments',
    href: '/adminpanel/payments'
  }
]

type LanguageDropdownProps = {
  languages: Array<SupportedLanguage>
}

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({languages}) => {
  const interfaceContext = useContext(InterfaceContext)

  const [selected, setSelected] = useState<SelectOptionType>({
    value: interfaceContext.lang, 
    label: langToWord(interfaceContext.lang, 'Name')
  })
  const languageOptions: Array<SelectOptionType> = []
  languages.forEach((l) => {
    languageOptions.push({
      value: l as string,
      label: langToWord(l, 'Name')
    })
  })

  useEffect(() => {
    interfaceContext.setLanguage(selected.value as SupportedLanguage)
  }, [selected, interfaceContext])

  return (
    <Select
      className="border border-gray-300"
      label={<Icon role="decorative" name="LanguageIcon"/>}
      labelLocation='inline'
      description="Select a language"
      options={languageOptions}
      value={selected}
      onChange={(value) => {setSelected(value)}}
    />
  )
}

const AdminPanelNav = () => {
  // TODO: update Theme provider to take in a size for the logo
  const {logo, languages} = useTheme();
  const {path} = useRouteMatch();

  const getTranslatedText = (lang?: keyof Text, value?: string | Text) => {
    if(typeof value === 'string' || !value) {
      return value;
    }
    return value[lang ?? 'en'] ?? value['en'];
  }

  const interfaceContext = useContext(InterfaceContext) 

  return (
    <SidebarNav>
      <SidebarNavHeader className='py-4'>
        <div>
          <LanguageDropdown languages={languages}/>
        </div>
        <div className="pt-2">
          {logo}
        </div>
      </SidebarNavHeader>

      <SidebarNavContent>
        <SidebarNavMenu>
          {NAV_ITEMS.map((item, idx) => {
            return (
              <SidebarNavMenuItem key={idx}>
                <SidebarNavMenuButton href={item.href} isActive={item.href === path}>
                  <span key={idx}>{getTranslatedText(interfaceContext.lang, item.name)}</span>
                </SidebarNavMenuButton>
              </SidebarNavMenuItem>
            )
          })}
        </SidebarNavMenu>
      </SidebarNavContent>
    </SidebarNav>
  )
}


// TODO: use AppShell to build out an OverviewPage -- this is just temporary to test out the ThemeProvider
const OverviewPage = () => {
  const publicConfig = useContext(PublicConfigurationContext);
  const history = useHistory()

  if (publicConfig && publicConfig.adminPanel === false){
    history.push("/");
  }

  return (
    <Page 
      sidebar={
        <AdminPanelNav />
      }>
      <div>Content</div>
    </Page>
  )
}

export const AdminPanelApp = () => {
  let { path } = useRouteMatch();

  return (
    <ThemeProvider>
      <SidebarNavProvider>
        <Switch>
          <Route path={`${path}/overview`} component={OverviewPage} />
        </Switch>
      </SidebarNavProvider>
    </ThemeProvider>      
  )
}

export default AdminPanelApp;